module.exports = __webpack_public_path__ + "static/media/usa.d4cae792.webp";